import { React, useState } from 'react';
import { Dialog } from '@mui/material';
import { ButtonComponent } from 'component/Button';
import { ReactComponent as CancelSvg } from 'assets/images/icons/close_24px.svg';
import 'assets/styles/pages/templates.scss';
import { ReactComponent as ViewIcon } from 'assets/images/icons/Eye-on.svg';
import { NTSAttributesBlock } from './NTSAttributes';
import { HAAttributesBlock } from './HAAtrributes';
import { EoreAttributesBlock } from './EoreAttributes';
import { CLEARANCE_SCHEMA } from './ClearanceSchema';
import { CLEARANCE_DAILY_SCHEMA } from './ClearanceDailySchema';
import { CLEARANCE_WEEKLY_SCHEMA } from './ClearanceWeeklySchema';

const findKey = (obj, targetKey) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (key === targetKey) {
        return obj[key];
      } if (typeof obj[key] === 'object') {
        const result = findKey(obj[key], targetKey);
        if (result !== undefined) {
          return result;
        }
      }
    }
  }
  return undefined;
};

function hasTrueChildProperty(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      if (hasTrueChildProperty(obj[key])) {
        return true;
      }
    } else if (obj[key] === true) {
      return true;
    }
  }
  return false;
}

const ViewAttributes = (props) => {
  const selectedNtsBlocks = {
    general: hasTrueChildProperty(props.fields.general),
    location: hasTrueChildProperty(props.fields.location),
    nto_result: hasTrueChildProperty(props.fields.nto_result),
  };
  const selectedHaBlocks = {
    general: hasTrueChildProperty(props.fields.general),
    examination_date: hasTrueChildProperty(props.fields.general?.examination_date),
    location: hasTrueChildProperty(props.fields.location),
    hazard_type: hasTrueChildProperty(props.fields.hazard_type),
    evidences: hasTrueChildProperty(props.fields.evidences),
    direct_evidences: hasTrueChildProperty(props.fields.evidences?.direct_evidences),
    indirect_evidences: hasTrueChildProperty(props.fields.evidences?.indirect_evidences),
    polygon_info: hasTrueChildProperty(props.fields.polygon_info),
    geographic_and_terrain_description: hasTrueChildProperty(props.fields
      .geographic_and_terrain_description),
    next_landrelease_activity: hasTrueChildProperty(props.fields.next_landrelease_activity),
    landuse_and_beneficiaries: hasTrueChildProperty(props.fields.landuse_and_beneficiaries),
    number_of_direct_beneficiaries: hasTrueChildProperty(props.fields
      .number_of_direct_beneficiaries),
    number_of_indirect_beneficiaries: hasTrueChildProperty(props.fields
      .number_of_indirect_beneficiaries),
    informators: hasTrueChildProperty(props.fields.informators),
  };

  let selectedEoreBlocks = {
    general: hasTrueChildProperty(props.fields?.general),
    session_information: hasTrueChildProperty(props.fields?.session_information),
    direct_beneficiaries: hasTrueChildProperty(props.fields
      ?.session_information?.direct_beneficiaries),
    indirect_beneficiaries: hasTrueChildProperty(props.fields
      ?.session_information?.indirect_beneficiaries),
    contact_person: hasTrueChildProperty(props.fields?.session_information?.contact_person),
    final_indicators: hasTrueChildProperty(props.fields?.final_indicators),
    eore_point: hasTrueChildProperty(props.fields?.eore_point),
  };
  const selectedClearanceBlocks = {};
  if (props.type === 'cl_task' || props.type === 'clearance') {
    selectedClearanceBlocks.ha = hasTrueChildProperty(props.fields?.ha);
    selectedClearanceBlocks.gis = hasTrueChildProperty(props.fields?.gis);
    selectedClearanceBlocks.tcp = hasTrueChildProperty(props.fields?.tcp);
    selectedClearanceBlocks.team = hasTrueChildProperty(props.fields?.team);
    selectedClearanceBlocks.files = hasTrueChildProperty(props.fields?.files);
    selectedClearanceBlocks.cl_task_id = hasTrueChildProperty(props.fields?.cl_task_id);
    selectedClearanceBlocks.created_at = hasTrueChildProperty(props.fields?.created_at);
    selectedClearanceBlocks.progress_map = hasTrueChildProperty(props.fields?.progress_map);
    selectedClearanceBlocks.comments_summary = hasTrueChildProperty(props.fields?.comments_summary);

    selectedClearanceBlocks.general = hasTrueChildProperty(props.fields?.ha?.general);
    selectedClearanceBlocks.location = hasTrueChildProperty(props.fields?.ha?.location);
    selectedClearanceBlocks.turn_points = hasTrueChildProperty(props.fields?.ha?.turn_points);
  } else if (Array.isArray(props.ClearanceAttributes)) {
    props.ClearanceAttributes.forEach((attribute) => {
      const value = findKey(props.fields, attribute.name);
      let checked = false;
      if (typeof value === 'object') {
        checked = hasTrueChildProperty(value);
      } else if (typeof value === 'boolean') {
        checked = value;
      }
      selectedClearanceBlocks[attribute.name] = checked;
    });
  }
  const selectedClDailyBlocks = {};
  if (props.type === 'cl_daily') {
    selectedClDailyBlocks.dms = hasTrueChildProperty(props.fields?.dms);
    selectedClDailyBlocks.field_work = hasTrueChildProperty(props.fields?.field_work);
    selectedClDailyBlocks.marking = hasTrueChildProperty(props.fields?.marking);
    selectedClDailyBlocks.eo_found_tab = hasTrueChildProperty(props.fields?.eo_found_tab);
    selectedClDailyBlocks.cl_daily_id = hasTrueChildProperty(props.fields?.cl_daily_id);
    selectedClDailyBlocks.created_at = hasTrueChildProperty(props.fields?.created_at);
    selectedClDailyBlocks.comments_summary = hasTrueChildProperty(props.fields?.comments_summary);
  }
  const selectedClWeeklyBlocks = {};
  if (props.type === 'cl_weekly') {
    selectedClWeeklyBlocks.dms = hasTrueChildProperty(props.fields?.dms);
    selectedClWeeklyBlocks.field_work = hasTrueChildProperty(props.fields?.field_work);
    selectedClWeeklyBlocks.marking = hasTrueChildProperty(props.fields?.marking);
    selectedClWeeklyBlocks.eo_found_tab = hasTrueChildProperty(props.fields?.eo_found_tab);
    selectedClWeeklyBlocks.cl_daily_id = hasTrueChildProperty(props.fields?.cl_daily_id);
    selectedClWeeklyBlocks.created_at = hasTrueChildProperty(props.fields?.created_at);
    selectedClWeeklyBlocks.comments_summary = hasTrueChildProperty(props.fields?.comments_summary);
  }
  return (
    <>
      {props.type === 'nts'
        && (
          <NTSAttributesBlock
            reportType={props.type}
            selectedNtsBlocks={selectedNtsBlocks}
            findKey={findKey}
            selectedNtsAttr={props.fields}
            NTSAttributes={props.NTSAttributes}
            viewMode
          />
        )}
      {(props.type === 'clearance' || props.type === 'cl_task')
        && (
          <NTSAttributesBlock
            reportType={props.type}
            selectedNtsBlocks={selectedClearanceBlocks}
            findKey={findKey}
            selectedNtsAttr={props.fields}
            NTSAttributes={props.ClearanceAttributes || CLEARANCE_SCHEMA}
            viewMode
          />
        )}
      {props.type === 'cl_daily'
        && (
          <NTSAttributesBlock
            reportType={props.type}
            selectedNtsBlocks={selectedClDailyBlocks}
            findKey={findKey}
            selectedNtsAttr={props.fields}
            NTSAttributes={props.ClDailyAttributes || CLEARANCE_DAILY_SCHEMA}
            viewMode
          />
        )}
      {props.type === 'cl_weekly'
        && (
          <NTSAttributesBlock
            reportType={props.type}
            selectedNtsBlocks={selectedClWeeklyBlocks}
            findKey={findKey}
            selectedNtsAttr={props.fields}
            NTSAttributes={CLEARANCE_WEEKLY_SCHEMA}
            viewMode
          />
        )}
      {props.type === 'ha'
        && (
          <HAAttributesBlock
            reportType={props.type}
            selectedHaBlocks={selectedHaBlocks}
            findKey={findKey}
            selectedHaAttr={props.fields}
            HAAttributes={props.HAAttributes}
            viewMode
          />
        )}
      {props.type === 'eore'
        && (
          <EoreAttributesBlock
            reportType={props.type}
            selectedEoreBlocks={selectedEoreBlocks}
            findKey={findKey}
            selectedEoreAttr={props.fields}
            EoreAttributes={props.EoreAttributes}
            viewMode
          />
        )}
    </>
  );
};

export const ViewTemplate = (props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="drone-new-btn">
      <ViewIcon
        className="view-icon"
        onClick={handleClickOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        className="templates-modal"
      >
        <div className="confirm-popup popup">
          <div className="header">
            <span className="title">Template view</span>
            <span className="closeBtn" onClick={handleClose} />
          </div>

          <div className="flex-column-group">
            <div className="flex-group flex-between">
              <div className="double-text">
                <span>Template name</span>
                <span>{props.template.name}</span>
              </div>

            </div>
            <div className="flex-group">
              <div className="double-text">
                <span>Template type</span>
                <span>{props.template.type.toUpperCase()}</span>
              </div>
            </div>
            <div className="flex-group">
              <div className="double-text">
                <span>Attributes</span>
                <div className="attributes">
                  <ViewAttributes
                    fields={props.template.fields}
                    type={props.template.type}
                    HAAttributes={props.HAAttributes}
                    NTSAttributes={props.NTSAttributes}
                    EoreAttributes={props.EoreAttributes}
                    ClearanceAttributes={props.ClearanceAttributes}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="buttons-group">
            <ButtonComponent
              className="danger"
              iconLeft={<CancelSvg />}
              handleButton={() => {
                handleClose();
              }}
              label="Cancel"
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};
